module.exports = __webpack_public_path__ + "media/images/torchlit_tales_name-4f1c30555d814fed359cd13ec65a7adc.png";